// Copyright (c) 2016 Deere & Company

export const isLengthWithinRange = (queryString, maxLength, minLength) => minLength <= queryString.length && queryString.length <= maxLength;
export const isLengthAtLeast = (queryString, minLength) => minLength <= queryString.length;



// WEBPACK FOOTER //
// ./src/shared/services/validation-service.js